/* eslint-disable func-names */
/* eslint-disable default-param-last */
import { SET_REBOOK_OPTIONS } from '../Actions';

export default function (state = {}, action) {
  switch (action.type) {
    case SET_REBOOK_OPTIONS:
      return action.payload;
    default:
      return state;
  }
}
